import { expLogJSON } from '@/common/utils/log-utils/report';

//曝光埋点
export function exposureLog(ids) {
  expLogJSON('yx_center', 'workbench_signupinfo', JSON.stringify({ cardId: ids }));
}

// tab切换埋点
export function tabLog(value) {
  window.log('yx_center', 'workbench_signuptab', JSON.stringify({ activitytab: value }));
}

// 场景类型区分
export function typeLog(value) {
  window.log('yx_center', 'workbench_signuptype', JSON.stringify({ signuptype: value }));
}

// 点击报名。查看详情
export function applyLog(id, type) {
  window.log('yx_center', 'workbench_signup', JSON.stringify({ cardId: id, ljbmckxq: type }));
}

// 收藏
export function collectLog(id) {
  window.log('yx_center', 'workbench_collect', JSON.stringify({ cardId: id }));
}
